import { apiClient } from '@/shared/api/client';
import type {
  SuperAdmin,
  CreateSuperAdminRequest,
  UpdateSuperAdminRequest,
} from '../types/super-admin.types';
import type { ApiResponse } from '@/shared/types/api.types';

export const superAdminService = {
  async listSuperAdmins(): Promise<SuperAdmin[]> {
    const response = await apiClient<ApiResponse<SuperAdmin[]>>('/auth/users/super-admins', {
      method: 'GET',
    });
    return response.data;
  },

  async createSuperAdmin(request: CreateSuperAdminRequest): Promise<SuperAdmin> {
    const response = await apiClient<ApiResponse<{ user: SuperAdmin }>>('/auth/users', {
      method: 'POST',
      body: {
        email: request.email,
        firstName: request.firstName,
        lastName: request.lastName,
        password: request.password,
        initialRole: 'SUPER_ADMIN',
        sendPasswordResetEmail: request.sendPasswordResetEmail ?? false,
      },
    });
    return response.data.user;
  },

  async updateSuperAdmin(userId: string, request: UpdateSuperAdminRequest): Promise<SuperAdmin> {
    const response = await apiClient<ApiResponse<SuperAdmin>>(
      `/auth/users/super-admins/${userId}`,
      {
        method: 'PUT',
        body: request,
      }
    );
    return response.data;
  },

  async sendPasswordReset(userId: string): Promise<void> {
    await apiClient(`/auth/users/super-admins/${userId}/password-reset`, { method: 'POST' });
  },

  async deactivateSuperAdmin(userId: string): Promise<SuperAdmin> {
    const response = await apiClient<ApiResponse<SuperAdmin>>(
      `/auth/users/super-admins/${userId}/deactivate`,
      {
        method: 'PATCH',
      }
    );
    return response.data;
  },

  async activateSuperAdmin(userId: string): Promise<SuperAdmin> {
    const response = await apiClient<ApiResponse<SuperAdmin>>(
      `/auth/users/super-admins/${userId}/activate`,
      {
        method: 'PATCH',
      }
    );
    return response.data;
  },
};
